export default __webpack_public_path__ + "static/media/Snd3.11c8e622.mp3";